import { useQuery } from '@apollo/client'
import { Select, SelectProps } from 'antd'
import React, { useMemo } from 'react'
import { SYMPTOME_QUERY } from '../../apollo/query/symptone.query'
import { D4_Symptometypeequipement } from '../../types'

const D4SelectSymptome: React.FC<SelectProps<any> & { equipementId: number }> = ({ equipementId, ...rest }) => {
  const { data: symptomes } = useQuery<{ symptomes: D4_Symptometypeequipement[] }, { equipementId: number }>(
    SYMPTOME_QUERY,
    { skip: !equipementId, variables: { equipementId } }
  )

  const symptomeOptions = useMemo(
    () => symptomes?.symptomes.map((eq) => ({ label: eq.symptome, value: eq.id })),
    [symptomes?.symptomes]
  )

  return (
    <Select
      options={symptomeOptions}
      showArrow
      showSearch
      optionFilterProp="label"
      style={{ width: '100%' }}
      placeholder="Selectionnez un symptome"
      {...rest}
      // disabled={!form.getFieldValue('equipement') || symptomeOptions?.length === 0}
    />
  )
}

export default D4SelectSymptome
